import React from "react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { MailCheck } from "lucide-react";
import Logo from "@/components/Logo";

export default function EmailValidation() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
      <div className="bg-white rounded-2xl shadow-lg p-8 max-w-lg w-full text-center">
        <div className="flex justify-center mb-8">
          <Logo className="text-2xl" />
        </div>
        <MailCheck className="h-14 w-14 text-[#7E69AB] mx-auto mb-4" />
        <h2 className="text-2xl font-bold mb-2 text-[#1A1F2C]">
          ¡Revisa tu bandeja de entrada!
        </h2>
        <p className="mb-4 text-gray-600 text-base">
          Hemos enviado un correo de verificación a <b>{user?.email}</b>.<br />
          Haz clic en el enlace para verificar tu email.
          <br />
          <span className="block mt-2 text-sm text-gray-500">
            Si no lo encuentras, revisa tu carpeta de spam o correo no deseado.
          </span>
        </p>
        <Button
          onClick={async () => {
            await signOut();
            navigate("/login");
          }}
          variant="outline"
          className="mt-4 w-full border-[#7E69AB] text-[#7E69AB] hover:bg-[#F8F7FF] hover:text-[#6E59A5] font-semibold">
          Cerrar sesión
        </Button>
      </div>
    </div>
  );
}
